// @flow
import { connect } from 'react-redux'
import ExcludedLocationsSelect from './ExcludedLocationsSelect'
import type { Store } from '../../redux/ducks'
import _ from 'lodash'
import store from '../../redux/store'
import { selectProperties } from './IncludedLocationsSelectContainer'
import { patch } from '../AudienceEditContainer'

function mapStateToProps(state: Store) {
  const audienceState = state.audienceEdit
  const initial = audienceState.initial

  if (!initial) return {}

  return {
    ...selectProperties(initial.locations.excludedSelectProperties),
    excludedLocationIds: audienceState.excludedLocationIds,
    errors: audienceState.excludedLocationsErrors,
    preloadedLocations: audienceState.preloadedLocations
  }
}

function mapDispatchToProps(dispatch: Function, ownProps) {
  return {
    onChange: (excludedLocationIds: Array<number>) => {
      patch(dispatch, { excludedLocationIds: excludedLocationIds })
      ownProps.onChange && ownProps.onChange()
    },
    onLocationsLoad: (locations) => {
      const state: Store = store.getState()
      patch(dispatch, {
        preloadedLocations: _.uniqBy(
          _.concat(state.audienceEdit.preloadedLocations, locations),
          (location) => location.id
        )
      })
    }
  }
}

const ExcludedLocationsSelectContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(ExcludedLocationsSelect)

export default ExcludedLocationsSelectContainer
